module.exports = __webpack_public_path__ + "static/OneClickPortals-ee7f96abb1df5e02bcb3e68c965c94e2.jpg";